export default __webpack_public_path__ + "static/media/user.b24acc3d.svg";